import { newAxiosIns } from '@/libs/axios'

export default function apiGetListContact() {
  return newAxiosIns.get('/komship/api/v1/whatsapp/list')
}
